import React, { createContext, useContext, useState } from "react";
import Firebase from "./Firebase";

export const FirebaseContext = createContext();
export const useFirebase = () => useContext(FirebaseContext);

const FirebaseContextProvider = (props) => {
  const firebase = new Firebase();
  const [user, setUser] = useState(null);
  const [laboratory, setLaboratory] = useState(null);

  return (
    <FirebaseContext.Provider
      value={{ firebase, laboratory, setLaboratory, user, setUser }}
    >
      {props.children}
    </FirebaseContext.Provider>
  );
};

export default FirebaseContextProvider;
